import { SearchX } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/lib/i18n/LanguageContext";
import { cn } from "@/lib/utils";

interface DocumentsFilteredEmptyStateProps {
  /** Omitted where nothing owns the filters (no provider) — the button is dropped. */
  onClearFilters?: () => void;
  className?: string;
}

/**
 * What a document view shows when its filters or search hide every row.
 *
 * Deliberately not DocumentsEmptyState: "Upload your first documents" on a
 * building that has documents, just none matching, reads as if they were gone.
 */
export function DocumentsFilteredEmptyState({
  onClearFilters,
  className,
}: DocumentsFilteredEmptyStateProps) {
  const { t } = useLanguage();
  const copy = t.documents.empty;
  return (
    <div className={cn("flex items-center justify-center p-12", className)}>
      <div className="flex max-w-sm flex-col items-center gap-2 text-center">
        <SearchX className="mb-1 h-8 w-8 text-muted-foreground" aria-hidden />
        <p className="text-sm font-medium">{copy.filteredTitle}</p>
        <p className="text-xs text-muted-foreground">{copy.filteredDescription}</p>
        {onClearFilters && (
          <Button variant="outline" size="sm" className="mt-2" onClick={onClearFilters}>
            {copy.clearFilters}
          </Button>
        )}
      </div>
    </div>
  );
}
